import React from "react";
import { NewTab, PageTab } from "../../../../../../components";
import LCAInformation from "./CreateManuval/LCAInformation";
import JobDetails from "./CreateManuval/JobDetails";

const CreateManuval = ({ onCancel, isEdit, setIsEdit, data, editData }) => {
  const CreateManuvalMenus = [
    {
      title: "LCA Information",
      page: (
        <LCAInformation
          onCancel={onCancel}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          data={data}
          editData={editData}
        />
      ),
      type: "main",
    },

    {
      title: "Job Details",
      page: (
        <JobDetails
          onCancel={onCancel}
          isEdit={isEdit}
          data={data}
          setIsEdit={setIsEdit}
          editData={editData}
        />
      ),
      type: "main",
    },
  ];
  return (
    <div className="py-3">
      <NewTab
        tabs={CreateManuvalMenus}
        color="black"
        variant="outlined"
        tabLevel="employees"
      />
    </div>
  );
};

export default CreateManuval;
